import { Component } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AiApiService } from 'src/app/core/services/ai-api.service';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { BlogListService } from 'src/app/core/services/list-services/blog-list.service';
import { BlogModalService } from 'src/app/core/services/modal-services/create-blog-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { BlogPageViewComponent } from 'src/app/pages/extrapages/blog-page-view/blog-page-view.component';

@Component({
  selector: 'app-view-blog-modal',
  templateUrl: './view-blog-modal.component.html',
  styleUrls: ['./view-blog-modal.component.scss']
})
export class ViewBlogModalComponent extends BlogPageViewComponent {
  
  constructor(
    private modalRef: NgbActiveModal,
    protected override blogListService: BlogListService,
    protected override blogModalService: BlogModalService,
    protected override url: ActivatedRoute,
    protected override aiApiService: AiApiService,
    protected myFileApiService: MyfileApiService,
    protected override authService: AuthMyfileService,
    protected override sanitizer: DomSanitizer,
  ) {
    super(blogListService, blogModalService, url,aiApiService, myFileApiService, authService, sanitizer);
  }

  close() {
    this.modalRef.close();
  }

  markAsRead(){
    if(this.authService.currentUserContextValue && this.authService.currentUserContextValue.id && this.model.id){
      this.blogListService.setViewedMostRecentInsight(this.authService.currentUserContextValue.id, this.model.id)
    }
    this.close();
  }

}
